export const brandCategories = ["全部", "品牌历史", "产品线", "发展历程", "企业文化", "荣誉资质"];

export const brandSortOptions = ["最新发布", "最早发布", "标题排序"];

export const brandArticles = [
  {
    id: "b1",
    title: "品牌起源：从一间小工作室到全国性品牌",
    category: "品牌历史",
    date: "2026-09-18",
    author: "品牌档案编辑部",
    readingTime: "6 分钟",
    tags: ["品牌起源", "创始故事"],
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20a%20small%20bright%20creative%20studio%20with%20wooden%20desks%20and%20pinned%20sketches%20on%20the%20wall%2C%20soft%20daylight%2C%20muted%20blue%20gray%20and%20orange%20accents%2C%20clean%20minimalist%20composition&width=1200&height=800&seq=brand-origin-01&orientation=landscape",
    summary:
      "从 2013 年的一间不足 40 平方米的工作室出发，想要XX 用十余年时间走出了一条属于自己的成长路径。本文完整梳理品牌起源与早期关键抉择。",
    content: [
      {
        heading: "一切的开始",
        paragraphs: [
          "2013 年春天，三名创始成员在上海市郊租下一间不足 40 平方米的工作室，这里有他们第一块手写白板，也有后来被无数用户记住的第一个产品原型。",
          "最初的目标非常朴素：把一件被认为是「麻烦事」的日常需求，做成一件顺手、可靠的事情。这个朴素的判断，后来成为想要XX 长期坚持的产品价值观。",
        ],
      },
      {
        heading: "第一个被记住的名字",
        paragraphs: [
          "品牌名称「想要XX」并非来自市场调研，而是来自早期用户的一句口头表达——「我就想要XX 这样的东西」。创始团队决定把这个真实的语气保留下来，让品牌从第一天起就贴近用户的表达方式。",
          "此后，品牌视觉也围绕「直接、清晰、可信」三个关键词逐步确立。",
        ],
      },
      {
        heading: "从工作室走向更大舞台",
        paragraphs: [
          "在成立后的第三个年头，想要XX 完成了从单一产品到多产品线的过渡，团队规模扩大到 60 余人，并开始建立独立的设计与研发体系。",
          "这一段经历被完整记录在品牌档案中，也成为后续多篇发展历程专题的起点。",
        ],
      },
    ],
  },
  {
    id: "b2",
    title: "产品线全景：三大板块如何彼此支撑",
    category: "产品线",
    date: "2026-09-02",
    author: "产品研究组",
    readingTime: "8 分钟",
    tags: ["产品线", "产品矩阵"],
    cover:
      "https://readdy.ai/api/search-image?query=Neat%20flat%20lay%20of%20three%20minimal%20product%20boxes%20arranged%20in%20a%20row%20on%20a%20pale%20gray%20surface%2C%20soft%20studio%20lighting%2C%20blue%20gray%20and%20orange%20color%20blocking%2C%20premium%20editorial%20product%20photography&width=1200&height=800&seq=brand-product-line&orientation=landscape",
    summary:
      "围绕「基础服务、专业工具、行业解决方案」三大板块，想要XX 形成了互相支撑的产品格局。本文用一张图讲清它们之间的定位差异与协同关系。",
    content: [
      {
        heading: "基础服务：把门槛降到最低",
        paragraphs: [
          "基础服务面向大多数个人用户，强调开箱即用与低学习成本。它是品牌与用户建立第一次信任的入口。",
          "这一板块承担了两个任务：验证真实需求，以及为专业工具输送真实使用场景。",
        ],
      },
      {
        heading: "专业工具：为深度用户而生",
        paragraphs: [
          "专业工具面向高频、深度使用的用户与团队，提供更强的定制能力与协作能力。",
          "在能力边界上，专业工具与基础服务保持一致的交互语言，降低用户在两者之间的迁移成本。",
        ],
      },
      {
        heading: "行业解决方案：把能力沉淀成方法",
        paragraphs: [
          "行业解决方案把通用能力与具体行业场景结合，输出可复用的配置与流程模板。",
          "三大板块并非彼此孤立，而是共用同一套底层能力与设计规范。",
        ],
      },
    ],
  },
  {
    id: "b3",
    title: "发展历程：十二年里的十个关键节点",
    category: "发展历程",
    date: "2026-08-15",
    author: "品牌档案编辑部",
    readingTime: "10 分钟",
    tags: ["发展历程", "里程碑"],
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20minimal%20timeline%20concept%20with%20soft%20ascending%20steps%20and%20small%20orange%20markers%20on%20a%20light%20gray%20background%2C%20clean%20geometric%20editorial%20illustration%2C%20blue%20gray%20tones&width=1200&height=800&seq=brand-timeline-01&orientation=landscape",
    summary:
      "从产品首次上线，到建立全国服务网络，十二年中有十个节点深刻影响了想要XX 的走向。本文按时间顺序逐个复盘。",
    content: [
      {
        heading: "起步期（2013 - 2015）",
        paragraphs: [
          "完成第一代产品上线，建立起最初的核心用户群。此阶段的关键词是「验证」。",
        ],
      },
      {
        heading: "扩张期（2016 - 2019）",
        paragraphs: [
          "团队规模快速扩大，产品线从单一走向多元，开始建立规范化的服务流程。",
          "这一阶段也奠定了品牌在行业中的基础认知。",
        ],
      },
      {
        heading: "成熟期（2020 - 至今）",
        paragraphs: [
          "引入更系统的研发与设计方法论，服务网络覆盖全国，并面向行业伙伴开放合作能力。",
          "品牌从「做出好产品」转向「让更多人用好能力」。",
        ],
      },
    ],
  },
  {
    id: "b4",
    title: "企业文化：我们如何定义「可靠」",
    category: "企业文化",
    date: "2026-07-28",
    author: "组织发展中心",
    readingTime: "5 分钟",
    tags: ["企业文化", "价值观"],
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20light%20interior%20of%20a%20calm%20modern%20meeting%20room%20with%20plants%20and%20natural%20wood%2C%20minimalist%20Scandinavian%20style%2C%20muted%20blue%20gray%20palette%20with%20warm%20orange%20highlights%2C%20editorial%20photography&width=1200&height=800&seq=brand-culture-01&orientation=landscape",
    summary:
      "「可靠」是想要XX 最常被提及的关键词，但它到底意味着什么？本文拆解品牌文化中的三条核心准则及其日常落地方式。",
    content: [
      {
        heading: "把承诺说小一点，把兑现做大一点",
        paragraphs: [
          "品牌内部有一条被反复强调的原则：对外承诺要保守，对内标准要苛刻。",
        ],
      },
      {
        heading: "看见细节，也承担细节",
        paragraphs: [
          "很多让用户感到安心的体验，来自大量看不见的细节投入。我们倾向于把这些细节当作产品的一部分，而非附加项。",
        ],
      },
      {
        heading: "让合作方也变好",
        paragraphs: [
          "我们相信长期的合作关系建立在共同成长之上。这一点同样体现在与合作伙伴的协作方式中。",
        ],
      },
    ],
  },
  {
    id: "b5",
    title: "荣誉资质：来自行业与用户的认可",
    category: "荣誉资质",
    date: "2026-07-05",
    author: "品牌档案编辑部",
    readingTime: "4 分钟",
    tags: ["荣誉", "资质认证"],
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20minimal%20still%20life%20of%20a%20framed%20certificate%20and%20a%20small%20trophy%20on%20a%20pale%20gray%20desk%2C%20soft%20directional%20light%2C%20restrained%20blue%20gray%20and%20orange%20tones%2C%20editorial%20product%20photography&width=1200&height=800&seq=brand-honor-01&orientation=landscape",
    summary:
      "十余年间，想要XX 获得了来自行业协会、专业机构与广大用户的诸多认可。本文汇总近三年具有代表性的荣誉与资质。",
    content: [
      {
        heading: "行业认可",
        paragraphs: [
          "连续三年入选行业年度优秀品牌名单，多个产品获得专业评测机构推荐。",
        ],
      },
      {
        heading: "资质认证",
        paragraphs: [
          "在产品与服务流程上通过多项体系认证，持续投入质量与信息安全管理。",
        ],
      },
      {
        heading: "用户口碑",
        paragraphs: [
          "比奖项更重要的是用户的长期选择。稳定复购与推荐，是对品牌最直接的认可。",
        ],
      },
    ],
  },
  {
    id: "b6",
    title: "品牌视觉：一套克制而清晰的设计语言",
    category: "企业文化",
    date: "2026-06-20",
    author: "品牌设计中心",
    readingTime: "7 分钟",
    tags: ["视觉规范", "设计语言"],
    cover:
      "https://readdy.ai/api/search-image?query=Graphic%20design%20desk%20scene%20with%20color%20swatches%20in%20blue%20gray%20and%20orange%2C%20grid%20paper%20and%20a%20stylus%2C%20top%20down%20flat%20lay%2C%20clean%20minimal%20editorial%20photography&width=1200&height=800&seq=brand-visual-01&orientation=landscape",
    summary:
      "蓝灰主色与橙色点缀，构成了想要XX 稳定而克制的视觉基调。本文说明这套设计语言背后的取舍逻辑。",
    content: [
      {
        heading: "为什么是蓝灰与橙",
        paragraphs: [
          "蓝灰传达专业与可信，橙色提供适度的活跃感与方向感。两者搭配时，橙色始终只承担强调角色。",
        ],
      },
      {
        heading: "留白是最好的秩序",
        paragraphs: [
          "我们倾向于用充足留白组织信息，而不是用更多线条与色块填满页面。",
        ],
      },
      {
        heading: "一致性高于惊喜",
        paragraphs: [
          "跨产品、跨渠道保持一致的视觉与交互语言，能让用户更快建立熟悉感。",
        ],
      },
    ],
  },
];